<template>
    <div>
        <v-list :color="!$vuetify.theme.dark ? 'grey lighten-4' : ''" class="py-0 mb-2">

            <div v-if="name" v-show="name" class="primary--text text-subtitle-2 px-4  pt-4 ">{{name}}
            </div>

            <slot />


        </v-list>



        <v-alert v-show="alert && !hideAlert" class="my-2 text-body-2" type="info" tile text  :icon="false">
            {{alert}}
        </v-alert>

    </div>
</template>

<script>
    export default {
        props: {
            name: String,
            alert: String,
            hideAlert: Boolean
        }
    }
</script>

<style>

</style>